import { DomSanitizer } from '@angular/platform-browser';
import { inject, Injectable } from '@angular/core';

// eslint-disable-next-line no-restricted-imports
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({ providedIn: 'root' })
export class IconRepositoryService {
  readonly #iconRegistry = inject(MatIconRegistry);
  readonly #sanitizer = inject(DomSanitizer);

  readonly #customIcons: [string, string][] = [
    ['arrow-down-filled', './assets/svg/source/my-icons/arrow-down-filled.svg'],

    ['editor-align-left', './assets/svg/source/html-editor/align-left.svg'],
    ['editor-a-font', './assets/svg/source/html-editor/color-picker.svg'],
    ['editor-b-font', './assets/svg/source/html-editor/bold.svg'],
    ['editor-t-font', './assets/svg/source/html-editor/text-edit.svg'],
    ['editor-i-font', './assets/svg/source/html-editor/italic.svg'],
    ['editor-u-font', './assets/svg/source/html-editor/underline.svg'],
    ['editor-undo', './assets/svg/source/html-editor/arrow-undo-left.svg'],
    ['editor-copy-file', './assets/svg/source/html-editor/documents-file-blank.svg'],
    ['editor-cross-a-font', './assets/svg/source/html-editor/pen-cross-delete.svg'],
    ['editor-double-arrow', './assets/svg/source/html-editor/code-text.svg'],
    ['editor-link-font', './assets/svg/source/html-editor/attachment-link.svg'],
    ['editor-redo', './assets/svg/source/html-editor/arrow-undo-right.svg'],
    ['editor-number-list', './assets/svg/source/html-editor/list-numbers.svg'],
    ['editor-point-list', './assets/svg/source/html-editor/list-paragraph-dots-checkmark.svg'],
    ['editor-quotes', '/assets/svg/source/html-editor/quote.svg'],
    ['text-edit', './assets/svg/source/html-editor/text-edit-a.svg'],
  ];

  constructor() {
    this.#customIcons.forEach(([iconName, iconPath]) => {
      this.#iconRegistry.addSvgIcon(iconName, this.#sanitizer.bypassSecurityTrustResourceUrl(iconPath));
    });
  }
}
